import type { ProjectVersionState } from '@/types/project';

export const PROJECT_VERSION_STATE_LABELS: Record<ProjectVersionState, string> = {
  draft: 'Draft',
  ready_for_review: 'Ready for review',
  reviewed: 'Reviewed',
  approved: 'Approved',
  po_handed_over: 'PO handed over',
  isa_handed_over: 'ISA handed over',
};

export function formatProjectVersionState(
  state: ProjectVersionState | (string & {}) | null | undefined,
): string | null {
  if (!state) return null;
  if (state in PROJECT_VERSION_STATE_LABELS) {
    return PROJECT_VERSION_STATE_LABELS[state as ProjectVersionState];
  }
  const humanized = state.replace(/_/g, ' ').trim();
  return humanized ? humanized.charAt(0).toUpperCase() + humanized.slice(1) : state;
}

export function lockedWriteBackMessage(
  state?: ProjectVersionState | (string & {}) | null,
): string {
  const label = formatProjectVersionState(state);
  const suffix = label ? ` (${label})` : '';
  return `This project version is locked in ThreatCat${suffix}. ThreatCat write-backs are unavailable until a new unlocked version is created in ThreatCat and synchronized.`;
}

export const STANDALONE_WRITE_BACK_MESSAGE =
  'This diagram was loaded from a file and is not linked to a ThreatCat project, so changes cannot be saved.';

export const READ_ONLY_WRITE_BACK_MESSAGE =
  'You have read-only access to this project and cannot edit diagram elements.';
